<template>
  <div v-if='shouldShow' class='result-tip-component result-component'>
    <div class="tip-flex">
      <div class="tip-column">
        <div v-if='config.image' class="result-image">
          <img :src='config.image'>
        </div>
      </div>
      <div class="tip-column">
        <div class="result-heading">
          <h2>{{ config.title }}</h2>
        </div>
        <div class="result-message">
          {{ config.show.message }}
        </div>
      </div>
      <div class="comp-type" v-if='debugMode == true'>
      <slot name='comptype'></slot>
    </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['config'],
  data () {
    return {
    }
  },
  computed: {
    shouldShow () {
      if (!this.exists(this.config.show)) {
        return false
      }

      if (this.config.show.condition === 'if') {
        return this.$store.state.answers[this.config.show.key] === this.config.show.value
      }

      if (this.config.show.condition === 'ifNot') {
        return this.$store.state.answers[this.config.show.key] !== this.config.show.value
      }

      return false
    }
  }
}
</script>
<style lang='scss'>
.result-tip-component {
  background-color: #ffffff;
  .tip-flex {
    max-width: 95%;
    margin: auto;
    padding: 2% 0;
  }
}
.result-tip-component:nth-child(even) {
  background-color: #f4f4f4;
}
@media screen and (min-width: 1024px) {
.result-tip-component {
  .tip-flex {
    display: flex;
    flex-direction: row;
    align-items: center;
    max-width: 85%;
    .tip-column {
      .result-image {
        padding: 0 15% 0 0;
      }
      .result-heading {
        text-align: left;
      }
      .result-message {
        text-align: left;
        margin-bottom: 1em;
      }
    }
    .tip-column:first-child {
      flex: 1 1 25%;
    }
    .tip-column:last-child {
      flex: 1 1 75%;
    }
  }
}
.result-tip-component:nth-child(even) .tip-flex {
  flex-direction: row-reverse;
  .result-image {
    padding: 0 0 0 15%;
  }
}
}
@media screen and (min-width: 1280px) {
.result-tip-component {
  .tip-flex {
    max-width: 70%;
    .tip-column {
      .result-image {
        padding: 0 20% 0 0;
      }
    }
  }
}
.result-tip-component:nth-child(even) .tip-flex {
  flex-direction: row-reverse;
  .result-image {
    padding: 0 0 0 20%;
  }
}
}
</style>
